module.exports = __webpack_public_path__ + "static/media/telegram-button.bfc272a9.png";